var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wincourse-load container"},[_c('div',{staticClass:"load-gif"},[_c('p',[_vm._v("信息正在解析中,请稍等...")])])])}]

export { render, staticRenderFns }